module.exports = __webpack_public_path__ + "img/sphere03-graph.7578a837.png";